var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotLoaderBouncy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 8,
    r: 1.5,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    begin: -0.4,
    calcMode: "spline",
    dur: 1,
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    values: "5;11;5;"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    begin: -0.2,
    calcMode: "spline",
    dur: 1,
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    values: "5;11;5;"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 8,
    r: 1.5,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    begin: 0,
    calcMode: "spline",
    dur: 1,
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    values: "5;11;5;"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotLoaderBouncy);
export default __webpack_public_path__ + "static/media/dot-loader-bouncy.c6587d017496c3f54fc04903801ddde7.svg";
export { ForwardRef as ReactComponent };